module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogProduct.tabs.usage":"Usage","views.dialogProduct.tabs.carbon":"Emissions","views.dialogProduct.tabs.trends":"Trends"}}')
  delete Component.options._Ctor
}
